// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import { useRouter } from 'next/router';
import { gql } from '@generated/gql';
import type { IProps } from '@components/Paragraphs/ParagraphTitle/ParagraphTitle';
import { getFragmentData } from '@generated/fragment-masking';
// #endregion Local Imports

export const ParagraphTitleFragment = gql(/* GraphQL */ `
  fragment ParagraphTitleFragment on ParagraphTitle {
    title: fieldTitle
    level: fieldLevel
  }
`);

export const ParagraphTitle: React.FunctionComponent<IProps.ParagraphTitle> = ({
  paragraph: _paragraph,
}) => {
  const router = useRouter();
  const paragraph = getFragmentData(ParagraphTitleFragment, _paragraph);
  const languageId = router.locale === 'fr' ? 1 : 0;
  const audioText = ['Artikel vorlesen lassen', "Faire lire l'article"];

  const { level, title } = paragraph;
  if (level! < 7) {
    return React.createElement(
      `h${level!}`,
      { className: title?.includes(audioText[languageId]!) && 'hide' },
      '',
      title,
    );
  }

  return (
    <>
      Warning, no definition for Level: {level} in {title}
    </>
  );
};
